var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-results" },
    [
      _vm.loading
        ? _c("Loading", { attrs: { text: "Die Jobs werden geladen..." } })
        : _vm.items !== null
        ? [
            _vm.showDataCompletionBox
              ? _c(
                  "NoMatches",
                  {
                    attrs: {
                      title:
                        "Wir sind auf der Suche nach deinem persönlichen Best-Match."
                    }
                  },
                  [
                    !_vm.hasMatches
                      ? _c("div", [
                          _c("b", [
                            _vm._v(
                              "Wenn du aktuell keine Matches siehst, mach dir keine Sorgen, das ist ganz normal."
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hasMatches
                      ? _c("div", { staticClass: "mt-1" }, [
                          _vm._v(
                            "\n\t\t\t\tskilldoo müllt dich nicht mit unpassenden Jobangeboten zu, sondern zeigt dir ausschließlich deine\n\t\t\t\tTop-Matches. Wir informieren dich per E-Mail, sobald es einen passenden Match gibt.\n\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3" }, [
                      _vm._v(
                        "\n\t\t\t\tUm deine Chancen zu erhöhen, ergänze noch folgende Punkte:\n\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "no-matches--content-button-container" },
                      [
                        !_vm.application.dataCompletion.skills.completed
                          ? _c("Button", {
                              attrs: {
                                text: "Meine Skills",
                                smaller: "",
                                href: "/kandidat/profil/kompetenzen"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.application.dataCompletion.education.completed
                          ? _c("Button", {
                              attrs: {
                                text: "Meine Ausbildung",
                                smaller: "",
                                href: "/kandidat/profil/lebenslauf"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasMatches && _vm.onlyExcluded
              ? _c("JonInfo", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "message",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\tDu hast derzeit keine ausgeschlossenen Jobs.\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2177699736
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasMatches
              ? _c(
                  "div",
                  { staticClass: "job-results--items" },
                  [
                    _c("Pagination", {
                      staticClass: "mb-4",
                      attrs: {
                        page: _vm.page,
                        total: _vm.meta.total,
                        "items-per-page": _vm.itemsPerPage
                      },
                      on: { input: _vm.load },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.items, function(listItem) {
                      return _c("ListItem", {
                        key: listItem.id,
                        attrs: { job: _vm.job, item: listItem },
                        on: {
                          addExclusion: function($event) {
                            return _vm.remove(listItem)
                          },
                          removeExclusion: _vm.load,
                          remove: function($event) {
                            return _vm.remove(listItem)
                          },
                          messagesClosed: function($event) {
                            return _vm.$emit("messagesClosed")
                          }
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("Pagination", {
                      staticClass: "mt-4",
                      attrs: {
                        page: _vm.page,
                        total: _vm.meta.total,
                        "items-per-page": _vm.itemsPerPage
                      },
                      on: { input: _vm.load },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }